import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { PermissionService } from '@services/permissions.service';
import { CredentialsApiService } from '@services/api-calls/credentials-api.service';

@Injectable()
export class AuthGuardService implements CanActivate {
    constructor(
        public router: Router,
        private permissionService: PermissionService,
        private credentialApiService: CredentialsApiService
    ) {}

    canActivate(route: ActivatedRouteSnapshot): Promise<boolean> | boolean {
        if (
            !localStorage.getItem('current_user') ||
            !localStorage.getItem('user-access')
        ) {
            const redirect_url = window.location.href;
            this.router.navigate(['login'], {
                queryParams: { redirect: redirect_url },
            });
            return false;
        } else {
            const routePermissions = route.data.permissions;
            let userPermissions = this.permissionService.permissionsValue;
            if (!userPermissions) {
                return new Promise((resolve) => {
                    this.credentialApiService.getUserAccess().subscribe(
                        (response) => {
                            const userAccessId =
                                localStorage.getItem('user-access');
                            userPermissions = response.find(
                                (userAccess) => userAccess.id === userAccessId
                            ).role.permissions;
                            this.permissionService.setPermissions(
                                userPermissions
                            );
                            resolve(
                                this.permissionService.hasPermissions(
                                    userPermissions,
                                    routePermissions
                                )
                            );
                        },
                        (error) => {
                            console.log(error);
                            resolve(false);
                            // todo: unauthorized page?
                        }
                    );
                });
            } else {
                return this.permissionService.hasPermissions(
                    userPermissions,
                    routePermissions
                );
            }
        }
    }
}
